var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Calendar-Jump-To-Date--Streamline-Core.svg",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Calendar Jump To Date Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar-jump-to-date"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.5 2c-0.26522 0 -0.51957 0.10536 -0.707107 0.29289C0.605357 2.48043 0.5 2.73478 0.5 3v9.5c0 0.2652 0.105357 0.5196 0.292893 0.7071 0.187537 0.1875 0.441887 0.2929 0.707107 0.2929h11c0.2652 0 0.5196 -0.1054 0.7071 -0.2929s0.2929 -0.4419 0.2929 -0.7071V3c0 -0.26522 -0.1054 -0.51957 -0.2929 -0.70711C13.0196 2.10536 12.7652 2 12.5 2h-2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.5 0.5v3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.5 0.5v3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.5 2h5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector 1240",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.41895 8.22449h5.16197",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector 1262",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m7.6416 10.1642 1.93972 -1.93969L7.6416 6.28479",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.67457188c38bdb25b3f022d0cd331403.svg";
export { ForwardRef as ReactComponent };